/**
 * Decides how many grid columns to render on phones (≤576px, non-fullscreen).
 *
 * - perLine "auto"            → 2 (unchanged auto behavior)
 * - explicit mobileSetsPerLine → clamped to 1..6
 * - no mobile value (legacy)  → today's behavior: perLine > 2 ? 2 : perLine
 *
 * Always returns at least 1.
 */
export const getGridMobileCols = ({
  perLine,
  mobileSetsPerLine,
}: {
  perLine: string;
  mobileSetsPerLine?: string | number;
}): number => {
  if (perLine === "auto") return 2;

  const hasMobile = mobileSetsPerLine !== undefined && mobileSetsPerLine !== "";
  if (hasMobile) {
    const mobile = Number(mobileSetsPerLine);
    if (Number.isFinite(mobile)) return Math.min(6, Math.max(1, mobile));
  }

  const desktop = Number(perLine);
  if (!Number.isFinite(desktop)) return 1;
  return Math.max(1, desktop > 2 ? 2 : desktop);
};
